import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const pvJahresvergleichReducer = (state = {
    PvJahresvergleichUI: null,
    SollVsIstUI: null,
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_PvJahresvergleich_pvJahresvergleichReducer":
            return { ...state, PvJahresvergleichUI: action.value, isLoaded: true };
        case "RECEIVE_SollVsIst_pvJahresvergleichSollVsIstReducer":
            return { ...state, SollVsIstUI: action.value };
        // Bei forceRefresh: Alte Daten sofort leeren
        case requestTypes.requestStartType.type:
            return { ...state, PvJahresvergleichUI: null, isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default pvJahresvergleichReducer;
